// wc2-zone-state.js
// Pure (no window/document) helpers for the upload-zone State-A/State-B
// re-entry banner, kept dependency-free so they unit-test under Node — same
// pattern as wc2-recovery-map.js. The DOM-touching callers
// (markZoneInFlight / revertZoneInFlight) live in wcNN-upload.js.

// While a NEW generation is in-flight, the State-B banner reflects it: the
// count is the number of FINISHED gens already saved for this PDP, plus 1 for
// the one currently being made. Non-numeric input is treated as 0.
export function inFlightCountLabel(storedCount) {
  var n = (Number(storedCount) || 0) + 1;
  return { count: n, noun: n === 1 ? 'generation' : 'generations' };
}
